// ─── Colores de los gráficos del panel ──────────────────────────────────────
// Validados con el método del boceto (separación para daltonismo y contraste,
// en claro y en oscuro). El color nunca es la única señal: cada serie lleva
// además su texto, su forma o su etiqueta. El color de una barra simple es el
// primario del seminario (el tema MUI).

export type Mode = 'light' | 'dark';

/** Una ventana de cohorte = una posición fija (el color sigue a la ventana). */
export const COHORT_COLORS: Record<Mode, string[]> = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
};
/** Una forma por ventana: la segunda señal, además del color. */
export const COHORT_SHAPES = [
  'circle',
  'square',
  'triangle',
  'diamond',
  'tdown',
  'circle',
  'square',
  'triangle',
] as const;

/** Segmentos de nota: el grupo que aprueba en azules (A más intenso), F-W en rojos. */
export const GRADE_COLORS: Record<Mode, Record<string, { fill: string; ink: string }>> = {
  light: {
    A: { fill: '#104281', ink: '#ffffff' },
    B: { fill: '#256abf', ink: '#ffffff' },
    C: { fill: '#5598e7', ink: '#0f172a' },
    D: { fill: '#86b6ef', ink: '#0f172a' },
    other: { fill: '#8fa3c4', ink: '#0f172a' },
    F: { fill: '#b8322f', ink: '#ffffff' },
    W: { fill: '#ec9a92', ink: '#0f172a' },
  },
  dark: {
    A: { fill: '#b7d3f6', ink: '#0f172a' },
    B: { fill: '#6da7ec', ink: '#0f172a' },
    C: { fill: '#3987e5', ink: '#0f172a' },
    D: { fill: '#1c5cab', ink: '#ffffff' },
    other: { fill: '#5d7095', ink: '#ffffff' },
    F: { fill: '#ef7a78', ink: '#0f172a' },
    W: { fill: '#a8403f', ink: '#ffffff' },
  },
};
